import {Button} from 'platform/components';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

export interface AddSectionButtonProps extends TestIdProps {
  onClick: () => void;
}

export function AddSectionButton(props: AddSectionButtonProps) {
  return (
    <div>
      <Button
        variant="outlined"
        title={i18n.t('entity.recordAudit.checklist.addSection')}
        onClick={props.onClick}
        data-testid={suffixTestId('addSection', props)}
      />
    </div>
  );
}
